import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4eb38d3f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "header-title"
};
const _hoisted_3 = {
  class: "header-info"
};
const _hoisted_4 = {
  class: "header-info-text header-info-issuetime"
};
const _hoisted_5 = {
  class: "header-info-right"
};
const _hoisted_6 = {
  class: "header-info-text header-info-view"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon t-icon-view"
}, null, -1));
const _hoisted_8 = {
  class: "header-info-text header-info-like"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon t-icon-like"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$data;
  const _component_el_skeleton = _resolveComponent("el-skeleton");
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("h1", _hoisted_2, _toDisplayString((_ctx$data = _ctx.data) === null || _ctx$data === void 0 ? void 0 : _ctx$data.title), 1), _createVNode(_component_el_skeleton, {
    rows: 0,
    loading: _ctx.isLoading,
    throttle: 0
  }, {
    default: _withCtx(() => {
      var _ctx$data2, _ctx$data3, _ctx$data4;
      return [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.data.author ? `${_ctx.data.author}/` : '') + " " + _toDisplayString(_ctx.formateIssuetime((_ctx$data2 = _ctx.data) === null || _ctx$data2 === void 0 ? void 0 : _ctx$data2.issue_at)), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createTextVNode(_toDisplayString((_ctx$data3 = _ctx.data) === null || _ctx$data3 === void 0 ? void 0 : _ctx$data3.view), 1)]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createTextVNode(_toDisplayString((_ctx$data4 = _ctx.data) === null || _ctx$data4 === void 0 ? void 0 : _ctx$data4.like), 1)])])])];
    }),
    _: 1
  }, 8, ["loading"])]);
}